import { useConfigSlice } from '../slices/config/selectors';

export const useBonusBalanceConfig = (): boolean => {
  const compliance = useConfigSlice.compliance();
  const casinoConfig = useConfigSlice.casinoConfig();

  return !!(compliance?.displayBonusBalance || casinoConfig?.showBonusBalance) && !casinoConfig?.hideBonusBalance;
};
